import React from "react";
import ErrorBoundry from "@components/ErrorBoundry/ErrorBoundry";
import {observer, inject} from "mobx-react";


function hash(s) {
    return s.split('')
        .reduce(
            (a, b) => (((a << 5) - a) + b.charCodeAt(0)) | 0,
            0
        )
} 

@inject("store")
@observer
export default class DoctypeTicker extends React.Component {
    interval = 1000;
    _ticker;
    _deadline;
    _id;
    constructor(props) {
        super(props);

        if (this.props.model.deadline) {
            this._deadline = new Date(this.props.model.deadline.replace(/-/g, "/")); // if date+time is passed, this is assumed to be local time. Only date values are converted to UTC.
        }

        // Generate unique id to avoid styles conflicting when we're using multiple tickers. This is used in the style element
        const h = hash(`${this.props.model.deadline || 0}|${this.props.model.fg || ""}|${this.props.model.bg || ""}|${this.props.model.text || ""}`);
        this._id = `ticker${h}`;

        this.state = {
            html: { __html: this._formatHtml() },
            style: this._formatStyle() // this requires that this._id has been set before calling
        }
    }

    _getIntervals(remaining) {
        let _remaining = remaining; // copy
        if (_remaining < 0) {
            // moment has passed :(
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                totalHours: 0,
                totalMinutes: 0,
                totalSeconds: 0
            };
        } else {
            const days = Math.floor(_remaining / (1000 * 60 * 60 * 24));
            _remaining -= days * (1000 * 60 * 60 * 24);

            const totalHours = Math.floor(remaining / (1000 * 60 * 60));
            const hours = Math.floor(_remaining / (1000 * 60 * 60));
            _remaining -= hours * (1000 * 60 * 60);

            const totalMinutes = Math.floor(remaining / (1000 * 60));
            const minutes = Math.floor(_remaining / (1000 * 60));
            _remaining -= minutes * (1000 * 60);

            const totalSeconds = Math.floor(remaining / (1000));
            const seconds = Math.floor(_remaining / 1000);

            return {
                days,
                hours,
                minutes,
                seconds,
                totalHours,
                totalMinutes,
                totalSeconds
            };
        }
    }

    _formatHtml() {
        let deadline = this._deadline || 0;
        const intervals = this._getIntervals(deadline - new Date());

        // Update template with correct values
        let newHtml = this.props.model.text;
        for (const [name, value] of Object.entries(intervals)) {
            const valueWithLeadingZero = String(value).padStart(2, 0);
            newHtml = newHtml.replace(`{${name}}`, valueWithLeadingZero);
        }

        return newHtml;
    }

    _formatStyle() {
        const rules = [];
        if (this.props.model.fg) {
            rules.push(`#${this._id} { color : ${this.props.model.fg}; }`);
            rules.push(`#${this._id} * { color : ${this.props.model.fg}; }`); // fixes children having their text color overwritten by global styles
        }
        if (this.props.model.bg) {
            rules.push(`#${this._id} { background-color: ${this.props.model.bg}; }`); 
        }
        return rules.join(" ");
    }

    _tick() {
        const newHtml = this._formatHtml();
        if (this.state.html.__html !== newHtml) {
            this.setState({
                ...this.state,
                html: {
                    __html: newHtml
                }
            });
        }
    }
   
    componentDidMount() {
        if (this._ticker) clearInterval(this._ticker);

        // only start the ticker if we have a deadline and it's in the future
        if (this._deadline && this._deadline >= new Date()) {
            this._ticker = setInterval(() => {
                this._tick();
            }, this.interval);
        }
    }

    componentWillUnmount() {
        if (this._ticker) clearInterval(this.ticker);
    }

    _visible() {
        return this._deadline === undefined
            || (this._deadline !== undefined && this._deadline >= new Date());
    }

    render() {
        const style = this._formatStyle();
        return <ErrorBoundry>
            {<style>{ style }</style>}
            {this._visible() && <div className="ticker-bar" id={this._id} dangerouslySetInnerHTML={this.state.html}></div>}
        </ErrorBoundry>;
    }


}